import React, { FC, useState } from 'react';
// Core viewer
import { Viewer, Worker } from '@react-pdf-viewer/core';

// Plugins
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

type TViewPDFProps = {
  src?: string;
  name?: string;
};

const ViewPDF: FC<TViewPDFProps> = ({ src }) => {
  const [error, setError] = useState<string | null>(null);

  // Create plugin instance using a different approach
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  if (!src) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          padding: '20px',
        }}
      >
        <h3>No PDF source provided</h3>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          padding: '20px',
        }}
      >
        <h3>Error loading PDF</h3>
        <p>{error}</p>
        <button onClick={() => setError(null)}>Retry</button>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
        <div
          style={{
            height: '100%',
          }}
        >
          <Viewer
            fileUrl={src}
            transformGetDocumentParams={(params) => ({ ...params, isEvalSupported: false })}
            plugins={defaultLayoutPluginInstance ? [defaultLayoutPluginInstance] : []}
            onDocumentLoad={() => {
              setError(null);
            }}
          />
        </div>
      </Worker>
    </div>
  );
};

export default ViewPDF;
